<template>
    <div ref="barChart" style="width: 100%; height: 300px;"></div>
  </template>
  
  <script>
  import * as echarts from "echarts";
  
  export default {
    props: {
      data: Array,
    },
    mounted() {
      this.renderChart();

        console.warn("::::: STAGES NO GRAFICO :::: ", this.data)

        if (!Array.isArray(this.data)) {
            console.error("Os dados devem ser um array de objetos");
        }
    },
    methods: {
      renderChart() {
        const chart = echarts.init(this.$refs.barChart);
        chart.setOption({
          tooltip: {
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            data: this.data.map((item) => item.name),
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
                type: "bar",
                data: this.data.map((item) => ({
                value: item.value,
                itemStyle: {
                    color: item.color, // Cor personalizada
                },
                })),
            },
          ],
        });
      },
    },
  };
  </script>
  